import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvStatusChip from '../atoms/OvStatusChip';
import OvVideoReplacementNote from './OvVideoReplacementNote';
import OvVideoStatusChip from './OvVideoStatusChip';
import { AdminVideo } from '../../../common/model/dto/video/admin-video';
import { VideoUploadItem } from '../../../context/video-upload.types';
import { isArchived } from '../../../common/utils/video-status-utils';

interface OvVideoStatusSummaryProps {
  video: AdminVideo;
  upload?: VideoUploadItem;
}

const OvVideoStatusSummary: FC<OvVideoStatusSummaryProps> = ({
  video,
  upload,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Chips>
        <OvVideoStatusChip video={video} upload={upload} />
        {isArchived(video) && (
          <OvStatusChip label={t('videos.status.archived')} tone="neutral" />
        )}
      </Chips>
      {video.replaced_by_video_id && (
        <OvVideoReplacementNote replacementId={video.replaced_by_video_id} />
      )}
    </Wrapper>
  );
};

export default OvVideoStatusSummary;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
`;
